<script>
    export let id;

    import {videos} from './data.js';
    let renderVideo = true;

    $: src = "/content/videos/" + videos[id].file;
    $: { reMountVideo( src ) }
    function reMountVideo(){
        renderVideo = false;
        setTimeout(() => renderVideo = true, 0);
    }
</script>

{#if renderVideo === true}
    <video
            id="video-{id}"
            class="video-js"
            controls
            preload="auto"
            width="1280"
            height="528"
    >
        <source src="{src}" type="video/mp4">
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a
            web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank"
            >supports HTML5 video</a
            >
        </p>
    </video>
{/if}


<style>
    video {
        width: 90%;
        height: 90%;
    }
</style>